export const clientManagement = {
    title: 'クライアント管理',
    signUp: '新規登録',
    clientId: 'クライアントID',
    companyName: '企業名',
    industries: '部署名',
    contractDate: '作成日',
    terminated: 'ステータス',
    isTerminated: '解約済',
    isActive: '利用中',
    trial: 'トライアル',
    isStop: '緊急停止中',
    isCreating: '作成中',
    isErrored: 'エラー発生',
    userManagementName: 'ユーザー管理',
    aiManagement: 'AI分析結果管理',
    clientInfoManagementName: 'クライアント情報管理',
    inquiry: '問い合わせ',
    clientName: 'クライアント名',
    analysispermission: 'コンサル分析モード権限',
    analysispermissionNone: 'なし',
    analysispermissionFull: '全権',
    analysispermissionAvailable: 'あり',
    userFName: '名',
    userLName: '氏',
    mailAddress: 'メールアドレス',
    deleteFlag: 'ステータス',
    createdDate: '登録日',
    date: '日付',
    update: '更新',
    cancel: '取消',
    delete: '削除',
    add: '追加',
    emergencySuspend: '緊急公開停止',
    emergencyRestart: 'サービス再開',
    companyAddress: '住所',
    phoneNumber: '電話番号',
    trialStatus: 'オン',
    termination: '解約',
    stopTermination: '解約解除',
    EmailInformationToAnalyzed: '公開対象のクライアント情報',
    PublicTitle: '公開確認',
    mailReceiptDate: '受領日',
    aIanalysisResultInformation: '処理データ内情報',
    aiResultLoadingDate: 'AI分析結果搭載日',
    release: '公開',
    back: 'バック',
    subscriptionModel: 'サブスクリプション',
    promotionModel: 'プロモーション',
    statue: '状態',
    installDate: '搭載日',
    publicDate: '公開日',
    deleteDate: '削除日',
    mailRequestId: 'リクエストID',
    AITopFrom: '最頻Fromアドレス',
    AITopTo: '最頻Toアドレス',
    mailDomain1: 'メールドメイン１',
    mailDomain2: 'メールドメイン２',
    mailDomain3: 'メールドメイン３',
    // user Management
    userManagement: {
        active: '利用中',
        terminate: '削除済',
        reactive: '復活',
        create: '新規登録',
        update: '更新情報',
        userModalTitle: 'ユーザーの詳細情報',
        userInfo: {
            userFName: '名',
            userLName: '氏',
            mailAddress: 'メールアドレス',
            organization: '部署名',
            title: '役職',
            phoneNumber: '国際電話番号',
            phoneNumberTip: '（入力例：09012345678 の場合、+819012345678 と入力）',
            analysispermission: {
                label: 'コンサル分析モード権限',
                none: 'なし',
                full: '全権',
                available: 'あり'
            }
        },
        warningMsg: {
            duplicatedUser: '該当ユーザーは既に存在します。登録できません。',
            deleteInfo: 'ユーザーを削除します。問題ないでしょうか。',
            activeInfo: 'ユーザーを有効化にします。よろしいでしょうか。',
            userIdMissing: 'ユーザーIDがありません。認証前の可能性があります。'
        }
    },
    // clientInfo Management
    clientInfoManagement: {
        selectCompany: '企業名',
        confirmStopTitle: '解約前確認',
        confirmAcivityTitle: '解約処理のキャンセル',
        warningMsg: {
            companyNotMatch: '企業名は正しくありません。',
            terminationInfo: '該当クライアントを解約します。問題ないでしょうか。',
            canceltTerminationInfo: '該当クライアントを解約解除します。問題ないでしょうか。',
            terminationTips: '※解約後、該当クライアント関連ユーザーはログインできなくなりますので、ご注意ください。'
        }
    },
    suspendAndTermination: {
        emergencySuspendFalse: '緊急公開停止',
        emergencySuspendTrue: 'サービス再開',
        modalInfoFalse: 'クライアントへの情報公開を緊急停止しますか？',
        modalInfoTrue: 'クライアントへの情報公開を再開しますか？',
        modalConfirmFalse: '停止',
        modalConfirmTrue: '再開',
        modalCancel: 'キャンセル',
        invalidCompanyWarning: '企業名は正しくありません。'
    }
}
